import { useSelector } from 'react-redux';
import { StyledVoucherBar } from './style';

const VoucherBar = () => {
  const voucher = useSelector((state) => state.voucher);

  if(voucher){
    return (
      <StyledVoucherBar>
        {voucher.description}
      </StyledVoucherBar>
    )
  }
  else return null;
}

export default VoucherBar;
